import { formatName } from "src/utils/formatName";
import {
  CategoryFilterOption,
  BrandFilterOption,
  GeneralFilterOption,
} from "src/types/graphql.d";

// filter object from null and empty values and empty arrays
const filterObject = (obj: Record<string, any[] | any>) => {
  return Object.keys(obj).reduce((acc, key) => {
    const _acc: any = acc; // eslint-disable-line no-underscore-dangle
    if (Array.isArray(obj[key]) && obj[key].filter((i: any) => i).length > 0) {
      _acc[key] = obj[key];
    }
    if (!Array.isArray(obj[key]) && obj[key]) {
      _acc[key] = obj[key];
    }
    return _acc;
  }, {});
};

const strToArray = (x: any): string[] => (Array.isArray(x) ? x : x ? [x] : []);

/**
 * fn () Removing cateogories parent id before sending them
 **/
const transformCategories = (selectedCategories: any, categoryTree: any) => {
  const categories =
    (Array.isArray(selectedCategories)
      ? selectedCategories
      : [selectedCategories]) || [];

  let transformCategories = categories || []; // eslint-disable-line no-shadow
  categories.map((item) => {
    const parentOfCurrent =
      categoryTree &&
      categoryTree.find((i: any) => {
        if (i.id === item) {
          return i;
        }
      });
    if (categories?.includes(parentOfCurrent?.parent)) {
      transformCategories = transformCategories?.filter(
        (i: any) => i !== parentOfCurrent?.parent
      );
    }
  });

  return transformCategories;
};

const getNameBySlug = (
  slugName: string,
  data: { slug: string; name: string }[]
): string | undefined =>
  data.find(({ slug }: { slug: string }) => slug === slugName)?.name;

const getCategoryNameFromId = (
  categories: CategoryFilterOption[],
  id: string
) => {
  const name = categories.filter(
    (cat: CategoryFilterOption) => cat.id === id
  )[0]?.name;
  return formatName(name);
};

const getCategoryParentFromId = (
  categories: CategoryFilterOption[],
  id: string
) => {
  const parent = categories.filter(
    (cat: CategoryFilterOption) => cat.id === id
  )[0]?.parent;
  return parent;
};

const getBrandNameFromId = (brands: BrandFilterOption[], id: string) =>
  brands.filter((brand) => brand.id === id)[0]?.name;

const getNameById = (items: GeneralFilterOption[], id: string) =>
  items.filter((item) => item.id === id)[0]?.name;

export {
  filterObject,
  transformCategories,
  strToArray,
  getNameBySlug,
  getCategoryNameFromId,
  getCategoryParentFromId,
  getBrandNameFromId,
  getNameById,
};
